import React, { useState } from 'react';

import Form from '../../style-components/Form/Form.jsx';
import TextField from '../../style-components/Form/TextField.jsx';

// Formulario de nombre de unidad de aprendizaje, reutilizado para crear y editar.
// `onSave(name)` hace la llamada al endpoint y devuelve null si salió bien o un
// mensaje de error en caso contrario.
const LearnunitForm = ({ title, initialName = '', onSave, successMessage, setOpen }) => {
  const [name, setName] = useState(initialName);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      alert('El nombre no puede estar vacío.');
      return;
    }

    setLoading(true);
    const errorMessage = await onSave(trimmedName);
    setLoading(false);
    if (errorMessage) {
      alert(errorMessage);
      return;
    }
    alert(successMessage);
    setOpen(false);
    window.location.reload();
  };

  return (
    <Form title={title} onSubmit={handleSubmit} onClose={() => setOpen(false)} loading={loading}>
      <TextField
        name='name'
        label='Nombre'
        value={name}
        onChange={({ target }) => setName(target.value)}
        required
      />
    </Form>
  );
};

export default LearnunitForm;
